import { IDestroyOptions, Sprite, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { LocalizationModel } from "../../../common/models/LocalizationModel";
import { LocalizationKey } from "../../../localization/Localization";
import { nameof } from "bindable-data";
import { PlayerModel } from "../../../common/models/PlayerModel";
import { AdaptiveText } from "ui-pixijs";
import { SettingsModel } from "../../../common/models/SettingsModel";

export class LevelView extends Sprite {
    private readonly level: AdaptiveText;

    public constructor(
        private readonly settingsModel: SettingsModel,
        private readonly localizationModel: LocalizationModel,
        private readonly playerModel: PlayerModel,
        commonResources: CommonResourcesPackage
    ) {
        super(commonResources.assets_common_violet_placeholder_png);
        this.eventMode = "static";
        const format = localizationModel.getText(LocalizationKey.Level);
        this.level = new AdaptiveText(format.replace("{0}", playerModel.currentLevel.value.toString()), new LevelTextStyle(), 325, 90);
        this.addChild(this.level);
        this.level.updateText(false);
        this.level.position.set((this.width - this.level.width) * 0.5, 23);

        this.settingsModel.propertyChanged.add(this.onSettingsModelPropertyChange, this);
        this.playerModel.propertyChanged.add(this.onPlayerModelPropertyChange, this);
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.settingsModel.propertyChanged.remove(this.onSettingsModelPropertyChange, this);
        this.playerModel.propertyChanged.remove(this.onPlayerModelPropertyChange, this);
        super.destroy(options);
    }

    private onSettingsModelPropertyChange(model: SettingsModel, key: string): void {
        if (key != nameof(model, "language")) {
            return;
        }
        this.level.text = this.localizationModel.getText(LocalizationKey.Level).replace("{0}", this.playerModel.currentLevel.value.toString());
        this.level.position.set((this.width - this.level.width) * 0.5, 23);
    }

    private onPlayerModelPropertyChange(model: PlayerModel, key: string): void {
        if (key != nameof(model, "currentLevel")) {
            return;
        }
        this.level.text = this.localizationModel.getText(LocalizationKey.Level).replace("{0}", model.currentLevel.value.toString());
        this.level.position.set((this.width - this.level.width) * 0.5, 23);
    }
}

class LevelTextStyle extends TextStyle {
    public constructor() {
        super({
            fontSize: 55,
            fill: "#FFFFFF",
            fontFamily: GameFont.Default,
            dropShadow: true,
            dropShadowColor: "#7500d4",
            dropShadowBlur: 0.5,
            dropShadowDistance: 4,
            dropShadowAngle: 1.77,
            lineHeight: 80
        });
    }
}
